// 出入库api

import { axiosPost } from "@/utils/request";

/**
 * 查询出入库记录
 * @param {*} data
 * @returns
 */
export const listOutInputRecords = (data) => {
  return axiosPost({
    url: "/outInputRecords/selectOutInputRecords",
    data: data,
  });
};

/**
 * 查询出入库草稿
 * @param {*} data
 * @returns
 */
export const listOutInputRecordsDraft = (data) => {
  return axiosPost({
    url: "/outInputRecords/selectOutInRecordsDraft",
    data: data,
  });
};

/**
 * 标准入库
 * @param {*} data
 * @returns
 */
export const standardInputRecords = (data) => {
  return axiosPost({
    url: "/outInputRecords/standardInputRecords",
    data,
    tips: true,
  });
};
/**
 * 退货入库
 * @param {*} data
 * @returns
 */
export const returnInputRecords = (data) => {
  return axiosPost({
    url: "/outInputRecords/returnInputRecords",
    data,
    tips: true,
  });
};
/**
 * 调拨入库
 * @param {*} data
 * @returns
 */
export const allocationInputRecords = (data) => {
  return axiosPost({
    url: "/outInputRecords/allocationInputRecords",
    data,
    tips: true,
  });
};

/**
 * 标准出库
 * @param {*} data
 * @returns
 */
export const standardOutputRecords = (data) => {
  return axiosPost({
    url: "/outInputRecords/standardOutputRecords",
    data: data,
    tips: true,
  });
};
/**
 * 退货出库
 * @param {*} data
 * @returns
 */
export const returnOutputRecords = (data) => {
  return axiosPost({
    url: "/outInputRecords/returnOutputRecords",
    data: data,
    tips: true,
  });
};
/**
 * 调拨出库
 * @param {*} data
 * @returns
 */
export const allocationOutputRecord = (data) => {
  return axiosPost({
    url: "/outInputRecords/allocationOutputRecords",
    data: data,
    tips: true,
  });
};
/**
 * 根据申请单id 查询关联的产品记录
 * @param {*} applicationFormId
 * @returns
 */
export const selectProductRecordsByApplicationFormId = (applicationFormId) => {
  return axiosPost({
    url: "/outInputRecords/selectProductRecordsByApplicationFormId",
    data: { applicationFormId },
  });
};
/**
 * 校验入库设备号是否可以入库
 * @param {*} data
 * @returns
 */
export const verifyInputEqptCode = (data) => {
  return axiosPost({
    url: "/outInputRecords/verifyInputEqptCode",
    data: data,
  });
};
/**
 * 校验出库设备号是否可以出库
 * @param {*} data
 * @returns
 */
export const verifyOutputEqptCode = (data) => {
  return axiosPost({
    url: "/outInputRecords/verifyOutputEqptCode",
    data: data,
  });
};

/**
 * 入库
 * @param {*} data
 * @returns
 */
export const inputWarehouse = (data) => {
  return axiosPost({
    url: "/outInputRecords/inputWarehouse",
    data,
    tips: true,
  });
};
/**
 * 出库
 * @param {*} data
 * @returns
 */
export const outputWarehouse = (data) => {
  return axiosPost({
    url: "/outInputRecords/outputWarehouse",
    data,
    tips: true,
  });
};
/**
 * 检验出入库单设备
 * @param {*} data
 * @returns
 */
export const verifyOutInRecordEqptCode = (data) => {
  return axiosPost({
    url: "/outInputRecords/verifyOutInRecordEqptCode",
    data: data,
  });
};